// src/pages/NotificationEntryPoint.jsx
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const NotificationEntryPoint = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const next = `/market/notifications${location.search}`;

    if (currentUser) {
      navigate(next, { replace: true });
    } else {
      navigate("/login", { replace: true, state: { from: next } });
    }
  }, [currentUser, navigate, location.search]);

  return <div style={{ padding: "2rem", textAlign: "center" }}>Redirecting…</div>;
};

export default NotificationEntryPoint;
